import $ from "cash-dom";
export default function windowScrollTo(section) {
  var additionalOffset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var motionQuery = window.matchMedia("(prefers-reduced-motion)"); // Get current scroll to top

  var currentScroll = document.documentElement.scrollTop || document.body.scrollTop; // Get Header and subheader heights

  var headerHeight = $(".header").outerHeight();
  var subheaderHeight = 0;
  var subHeader = $(".anchormenu");

  if (subHeader.length > 0) {
    subheaderHeight = subHeader.outerHeight(true);
  }

  var headerAndSubnavHeight = headerHeight + subheaderHeight; // Get the distance from the section to the top of the page

  var sectionDistanceToTop = window.pageYOffset + section.getBoundingClientRect().top; // Scroll to the section

  window.scroll({
    behavior: motionQuery.matches ? "instant" : "smooth",
    top: sectionDistanceToTop <= currentScroll ? sectionDistanceToTop - headerAndSubnavHeight - additionalOffset : sectionDistanceToTop - subheaderHeight - additionalOffset,
    block: "start"
  });
}